<template>
  <section class="section">
    Editar productos quimicos
    <Registrar />
    <h3>Productos químicos registrados</h3>
    <button @click="refresh">refresh</button>
    <b-table
      :data="data"
      :columns="columns"
      :paginated="isPaginated"
      :per-page="perPage"
      :default-sort-direction="defaultSortDirection"
      :sort-icon="sortIcon"
      :mobile-cards="hasMobileCards"
      :bordered="isBordered"
      :narrowed="isNarrowed"
      :default-sort="data.name"
    ></b-table>
  </section>
</template>
<script>
import Registrar from '../components/matriz/components/registrar.vue'
const products = require('../components/matriz/js/products.js')

export default {
  data: () => {
    return {
      hasMobileCards: false,
      isBordered: true,
      isNarrowed: true,
      currentPage: 1,
      isPaginated: true,
      perPage: 10,
      defaultSortDirection: 'asc',
      sortIcon: 'arrow-up',
      sortIconSize: 'is-small',
      data: [],
      columns: [
        { field: 'id', label: 'ID', numeric: true, sortable: true },
        { field: 'name', label: 'NOMBRE', sortable: true },
        { field: 'codigo', label: 'CLASE', sortable: true },
        { field: 'descclase', label: 'DESCRIPCION' }
      ]
    }
  },
  beforeMount: function() {
    // se consulta el listado de productos químicos registrados
    this.refresh()
  },
  components: {
    Registrar
  },
  methods: {
    refresh: function() {
      var nuevo = this
      products.get(true).then(function(response) {
        nuevo.data = response
      })
    }
  }
}
</script>
